module.exports = __webpack_public_path__ + "static/media/HINDALCO_F1.d740dd22.txt";